<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">Wan Setting</h4>
        <el-form 
        :model="wanForm[wanIndex]"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wanForm"
        :disabled="$G_DEVICE_CFG.isReadOnly"
        >
            <el-form-item label="Connection Name:" >
                <el-select 
                v-model="wanIndex"
                placeholder="Please select WAN" 
                @change="changeWan"
                style="width: 100%">
                    <el-option 
                    v-for="(wan,index) in wanForm" 
                    :key="wan.index"
                    :label="wan.wanName" 
                    :value="index + ''"  
                    v-show="index != 0"></el-option>
                    <el-option label="New connection" value="0" :disabled="wanForm.length === maxWANNum + 1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Enable">
                <el-switch v-model="wanForm[wanIndex].enable"></el-switch>
            </el-form-item>
            <el-form-item label="Mode:" >
                <el-select 
                v-model="wanForm[wanIndex].mode"
                placeholder="Please select mode" 
                @change="changeWanMode"
                style="width: 100%">
                    <el-option label="Route" value="0"></el-option>
                    <el-option label="Bridge" value="1"></el-option>
                </el-select>
            </el-form-item>
            
            <!-- only route -->
            <div v-if="wanForm[wanIndex].mode === '0'">
                <el-form-item label="MTU:" prop="mtu">
                    <el-input v-model.number="wanForm[wanIndex].mtu"></el-input>
                </el-form-item>
                <el-form-item label="DHCP :">
                    <el-radio v-model="wanForm[wanIndex].netType" label="1">Automatically get IP address from ISP.</el-radio>
                </el-form-item>
                <el-form-item label="Static :">
                    <el-radio v-model="wanForm[wanIndex].netType" label="0">Configure static IP address from ISP.</el-radio>
                </el-form-item>
                <el-form-item label="PPPoE :">
                    <el-radio v-model="wanForm[wanIndex].netType" label="3" @change="clikcPPPoE">Please choose this option if using PPPoE connection.</el-radio>
                </el-form-item>
                <el-form-item label="IP Protocal Type:" >
                    <el-select 
                    v-model="wanForm[wanIndex].protocolType"
                    placeholder="Please select IP Protocal Type" 
                    style="width: 100%">
                        <el-option label="IPv4" value="1"></el-option>
                        <el-option label="IPv6" value="2"></el-option>
                        <el-option label="IPv4/6" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="NAT:">
                    <el-switch v-model="wanForm[wanIndex].nat"></el-switch>
                </el-form-item>
                <el-form-item label="IGMP Proxy:" v-if="wanForm[wanIndex].protocolType !== '2'">
                    <el-switch v-model="wanForm[wanIndex].enableIGMPProxy"></el-switch>
                </el-form-item>
             </div>
            <!-- only PPPoE -->
            <div v-if="wanForm[wanIndex].netType === '3'" key="PPPoE">
                <el-form-item label="PPPoE User Name:" prop="PPPoE.userName">
                    <el-input v-model="wanForm[wanIndex].PPPoE.userName"></el-input>
                </el-form-item>
                <el-form-item label="PPPoE Password:" prop="PPPoE.password">
                    <el-input type="password" v-model="wanForm[wanIndex].PPPoE.password"></el-input>
                </el-form-item>
                <el-form-item label="Dial Mode:" >
                    <el-select 
                    v-model="wanForm[wanIndex].PPPoE.dialMode"
                    placeholder="Please select Dial Mode" 
                    style="width: 100%">
                        <el-option label="Automatically" value="0"></el-option>
                        <el-option label="Dial on Demand" value="1"></el-option>
                        <el-option label="Manual connect" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- only Dial on Demand -->
                <el-form-item label="Idle Timeout:" 
                v-if="wanForm[wanIndex].PPPoE.dialMode === '1'" prop="PPPoE.idleTimeout">
                    <el-input v-model.number="wanForm[wanIndex].PPPoE.idleTimeout" placeholder="Rang [60~65535]s"></el-input>
                </el-form-item>
                <!-- only Manual connect and not add WAN-->
                <el-form-item 
                v-if="wanForm[wanIndex].PPPoE.dialMode === '2' && wanIndex != '0' ">
                    <el-button type="primary" @click="pppManualConnect('connect')">Connect</el-button>
                    <el-button type="info" @click="pppManualConnect('disconnect')">Disconnect</el-button>
                </el-form-item>
            </div>
            <el-form-item label="Enable VLAN:">
                <el-switch v-model="wanForm[wanIndex].enableVLAN"></el-switch>
            </el-form-item>
            <!-- VLAN is enable -->
            <div v-if="wanForm[wanIndex].enableVLAN" key="VLAN">
                <el-form-item label="VLAN ID:" prop="VLANID">
                    <el-input v-model.number="wanForm[wanIndex].VLANID" placeholder="Rang [1~4094]"></el-input>
                </el-form-item>
                <el-form-item label="802.1P:" >
                    <el-select 
                    v-model="wanForm[wanIndex]._802_1P"
                    placeholder="Please select 802.1P" 
                    style="width: 100%">
                        <el-option 
                        v-for="num in ['0','1','2','3','4','5','6','7']" 
                        :key="num" 
                        :label="num" 
                        :value="num">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!-- Service type -->
            <el-form-item label="Service Type:" >
                <el-select 
                v-model="wanForm[wanIndex].serviceType"
                @change="changeServerType"
                placeholder="Please select IP Service Type" 
                style="width: 100%">
                    <el-option v-for="type in wanServiceTypeArr" :key="type.value" :label="type.label" :value="type.value"></el-option>
                </el-select>
            </el-form-item>
            <!-- DHCP Passthrough only bridge-->
            <el-form-item v-if="wanForm[wanIndex].mode === '1'" label="Enable DHCP Passthrough:" >
                <el-switch v-model="wanForm[wanIndex].dhcpPassthrough"></el-switch>
            </el-form-item>
            <!-- IPv4  static-->
            <div v-if="wanForm[wanIndex].netType === '0' && wanForm[wanIndex].protocolType !== '2'" key="IPv4-static" >
                <el-form-item label="IP Address:" prop="ipv4.address">
                    <el-input v-model="wanForm[wanIndex].ipv4.address" placeholder="e.g. 10.10.10.100"></el-input>
                </el-form-item>
                <el-form-item label="Subnet Mask:" prop="ipv4.mask">
                    <el-input v-model="wanForm[wanIndex].ipv4.mask" placeholder="e.g. 255.255.255.0"></el-input>
                </el-form-item>
                <el-form-item label="Default Gateway:" prop="ipv4.gateway">
                    <el-input v-model="wanForm[wanIndex].ipv4.gateway" placeholder="e.g. 10.10.10.1"></el-input>
                </el-form-item>
                <el-form-item label="Primary DNS Server:" prop="ipv4.dns1">
                    <el-input v-model="wanForm[wanIndex].ipv4.dns1" placeholder="e.g. 10.10.10.1"></el-input>
                </el-form-item>
                <el-form-item label="Secondary DNS Server:" prop="ipv4.dns2">
                    <el-input v-model.trim="wanForm[wanIndex].ipv4.dns2" placeholder="e.g. 10.10.10.1"></el-input>
                </el-form-item>
            </div>
            <!-- IPv6 setting -->
            <div v-if="wanForm[wanIndex].protocolType !== '1'" key="IPv6-static">
                <el-form-item label="MLD Proxy:">
                    <el-switch v-model="wanForm[wanIndex].enableMLDProxy"></el-switch>
                </el-form-item>
                <!-- only dhcp/PPPoE -->
                <div v-if="wanForm[wanIndex].netType !== '0'">
                    <el-form-item label="Get IPv6 Address:" prop="ipv6.addressAutoType">
                        <el-radio-group v-model="wanForm[wanIndex].ipv6.addressAutoType" >
                            <el-radio label="3">DHCPv6</el-radio>
                            <el-radio label="2">SLAAC</el-radio>
                            <!-- only dhcp-->
                            <el-radio label="5" v-if="wanForm[wanIndex].netType === '1'">BRIGE</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="PD Enable:">
                        <el-switch v-model="wanForm[wanIndex].ipv6.enablePD"></el-switch>
                    </el-form-item>
                </div>
                
                <!-- only static -->
                <div v-if="wanForm[wanIndex].netType === '0'">
                    <el-form-item label="IPv6 Address:" prop="ipv6.address">
                        <el-input v-model="wanForm[wanIndex].ipv6.address" placeholder="e.g. fe88::26ca/64"></el-input>
                    </el-form-item>
                    <el-form-item label="Gateway IPv6 Address:" prop="ipv6.gateway">
                        <el-input v-model="wanForm[wanIndex].ipv6.gateway" placeholder="e.g. fe88::1"></el-input>
                    </el-form-item>
                    <el-form-item label="IPv6 PD Address:" prop="ipv6.pdAddr">
                        <el-input v-model="wanForm[wanIndex].ipv6.pdAddr" placeholder="e.g. 2022::"></el-input>
                    </el-form-item>
                    <el-form-item label="First IPv6 DNS:" prop="ipv6.dns1">
                        <el-input v-model="wanForm[wanIndex].ipv6.dns1" placeholder="e.g. fe88::1"></el-input>
                    </el-form-item>
                    <el-form-item label="Second IPv6 DNS:" prop="ipv6.dns2">
                        <el-input v-model.trim="wanForm[wanIndex].ipv6.dns2" placeholder="e.g. fe88::1"></el-input>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="Bound Ports:" >
                <!-- AIS LAN NUM 4 -->
                <el-checkbox-group v-model="wanForm[wanIndex].bindPort" v-if="$G_DEVICE_CFG.lanNum >= 4">
                    <el-checkbox label="0" :disabled = 'G_BindPort[0]' >LAN1</el-checkbox>
                    <el-checkbox label="1" :disabled = 'G_BindPort[1]' >LAN2</el-checkbox>
                    <el-checkbox label="2" :disabled = 'G_BindPort[2]' >LAN3</el-checkbox>
                    <el-checkbox label="3" :disabled = 'G_BindPort[3]' >LAN4</el-checkbox>
                </el-checkbox-group>
                <!-- GTD LAN NUM 2 -->
                <el-checkbox-group v-model="wanForm[wanIndex].bindPort" v-else>
                    <el-checkbox label="2" :disabled = 'G_BindPort[2]' >LAN1</el-checkbox>
                    <el-checkbox label="3" :disabled = 'G_BindPort[3]' >LAN2</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item >
                <el-checkbox-group v-model="wanForm[wanIndex].bindPort">
                    <el-checkbox label="10" :disabled = 'G_BindPort[10]'>SSID1</el-checkbox>
                    <el-checkbox label="12" :disabled = 'G_BindPort[12]'>SSID2</el-checkbox>
                    <el-checkbox label="13" :disabled = 'G_BindPort[13]'>SSID3</el-checkbox>
                    <el-checkbox label="14" :disabled = 'G_BindPort[14]'>SSID4</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-checkbox-group v-model="wanForm[wanIndex].bindPort">
                    <el-checkbox label="4" :disabled = 'G_BindPort[4]'>SSID5</el-checkbox>
                    <el-checkbox label="6" :disabled = 'G_BindPort[6]'>SSID6</el-checkbox>
                    <el-checkbox label="7" :disabled = 'G_BindPort[7]'>SSID7</el-checkbox>
                    <el-checkbox label="8" :disabled = 'G_BindPort[8]'>SSID8</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="$G_DEVICE_CFG.area!='TRUE'">
                <el-checkbox-group v-model="wanForm[wanIndex].bindPort">
                    <el-checkbox label="9" :disabled = 'G_BindPort[9]'>WLAN MESH</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="applyWAN">Apply</el-button>
                <el-button type="info" @click="deleteWAN" :disabled="wanIndex === '0'">Delete</el-button>
                <el-button type="primary" @click="refreshWAN">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import devConfig from '@/devConfig'

// route模式业务类型
const routeWanServiceType = [
    {label:'INTERNET_TR069',value:'0'},
    {label:'INTERNET',value:'1'},
    {label:'TR069',value:'2'},
    {label:'OTHER',value:'3'}, 
]

const routeWanServiceTypeForIPTV = [
    {label:'INTERNET_TR069',value:'0'},
    {label:'INTERNET',value:'1'},
    {label:'TR069',value:'2'},
    {label:'IPTV',value:'3'}, 
]

// Bridge模式业务类型
const bridgeWanServiceType = [
    {label:'INTERNET',value:'1'},
    {label:'OTHER',value:'3'}, 
]


// 初始化WAN连接数据
const defaultWANData = {
    wanName:'New connection',
    index:'0',
    enable:true,
    mode:'0', // 0=>Route 
    serviceType:'0',
    mtu:1480,
    netType:'1', // 0=>Static 1=>DHCP 3=>PPPoE
    protocolType:'1', // 1=>ipv4 2=>ipv6 3=>ipv4/6
    nat:true,
    enableVLAN:true,
    enableIGMPProxy:false,
    enableMLDProxy:false,
    VLANID:0,
    _802_1P:'0',
    bindPort:[],
    ipv4:{
        address:'',
        mask:'',
        gateway:'',
        dns1:'',
        dns2:'',
    },
    ipv6:{
        enablePD:true,
        addressAutoType:'3',
        address:'',
        gateway:'',
        dns1:'',
        dns2:'',
    },
    PPPoE:{
        userName:'',
        password:'',
        dialMode:'0', //0=>CONTINUOUS 1=>CONNECT_ON_DEMAND 2=>MANUAL 
        idleTimeout:60,
        manualConnect:false,
        lcpEnable:true,
        lcpInterval:30,
        lcpFailture:5
    }
}

//每次请求获取的WAN连接数据缓存
let getWANDataCache = [];

export default {
    data() {
        return {
            loading:false,
            lanNum:4, //AIS=>4 GTD=>2
            maxWANNum:4,//WAM连接创建最大个数
            wanServiceTypeArr:routeWanServiceType,
            G_BindPort:[],
            defaultBindPort:[],
            lanAndSSIDEnable:[],
            wanIndex:'0', // '0' =>add
            wanForm:[],
            formCheck:{
                mtu:[
                    { required: true, message: 'MTU cannot be empty.', trigger: 'blur' },
                    { type: 'number',min: 1, max: 1500, message: 'MTU range is [1-1500].', trigger: 'blur' }
                ],
                VLANID:[
                     { required: true, message: 'VLANID cannot be empty.', trigger: 'blur' },
                     { type: 'number',min: 1, max: 4094, message: 'VLANID range is [1-4094].', trigger: 'blur' }
                ],
                ipv4:{
                    address:[
                        { required: true, message: 'IP Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,4))
                                    callback(new Error('IP Address error! e.g. 10.10.10.100'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    mask:[
                        { required: true, message: 'Subnet Mask cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,4))
                                    callback(new Error('Subnet Mask error! e.g. 255.255.255.0'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    gateway:[
                        { required: true, message: 'Gateway cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,4))
                                    callback(new Error('Gateway error! e.g. 10.10.10.1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns1:[
                        { required: true, message: 'Primary DNS cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,4))
                                    callback(new Error('Primary DNS error! e.g. 10.10.10.1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns2:[
                        {
                            validator:(rule, value, callback) => {
                                if(value !== '' && !validator.isIP(value,4))
                                    callback(new Error('Secondary DNS error! e.g. 10.10.10.1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ]
                },
                ipv6:{
                    addressAutoType:[
                        {
                            validator:(rule, value, callback) => {
                                if(value === '' || parseInt(value) < 2)
                                    callback(new Error('Get IPv6 Address cannot be empty.'));
                                else
                                    callback()
                            },
                            trigger: 'change'
                        },
                    ],
                    address:[
                        { required: true, message: 'IPv6 Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                let ipv6Addr = value.split('/')
                                if(ipv6Addr.length === 1 || !validator.isIP(ipv6Addr[0],6))
                                    callback(new Error('IPv6 Address error! e.g. fe80::26ca/64'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    gateway:[
                        { required: true, message: 'Gateway IPv6 Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,6))
                                    callback(new Error('Gateway IPv6 Address error! e.g. fe88::1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    pdAddr:[
                        { required: true, message: 'IPv6 PD Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,6))
                                    callback(new Error('IPv6 PD  Address error! e.g. 2022::'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns1:[
                        { required: true, message: 'First IPv6 DNS cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,6))
                                    callback(new Error('First IPv6 DNS error! e.g. fe88::1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns2:[
                        {
                            validator:(rule, value, callback) => {
                                if(value !== '' && !validator.isIP(value,6))
                                    callback(new Error('Second IPv6 DNS error! e.g. fe88::1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ]
                },
                PPPoE:{
                    userName:[
                        { required: true, message: 'PPPoE User Name cannot be empty.', trigger: 'blur' },
                        { min: 1, max: 63, message: 'User Name length must be less than 63', trigger: 'blur' }
                    ],
                    password:[
                        { required: true, message: 'PPPoE Password cannot be empty.', trigger: 'blur' },
                        { min: 1, max: 63, message: 'PPPoE Password length must be less than 63', trigger: 'blur' }
                    ],
                    idleTimeout:[
                        { required: true, message: 'Idle Timeout cannot be empty.', trigger: 'blur' },
                        { type: 'number',min: 60, max: 65535, message: 'Idle Timeout range is [60-65535].', trigger: 'blur' }
                    ],
                    lcpInterval:[
                        { required: true, message: 'ICP Interval cannot be empty.', trigger: 'blur' },
                        { type: 'number',min: 0, max: 2592000, message: 'ICP Interval range is [0-2592000].', trigger: 'blur' }
                    ],
                    lcpFailture:[
                        { required: true, message: 'ICP Failure Num cannot be empty.', trigger: 'blur' },
                        { type: 'number',min: 0, max: 10000, message: 'ICP Failure Num  range is [0 - 10000].', trigger: 'blur' }
                    ]
                }
            }
            
        }
    },
    created(){
        this.getData()
        
        if(this.$G_DEVICE_CFG.area === 'WDC')
            this.wanServiceTypeArr = routeWanServiceTypeForIPTV
        else
            this.wanServiceTypeArr = routeWanServiceType
    },
    methods:{
        initBindPort(){
            // 每次切换WAN都需要重置一次所有端口禁用状态
            this.G_BindPort = this.defaultBindPort.slice()

            // 把当前绑定的端口的接触禁用状态
            this.wanForm[this.wanIndex].bindPort.forEach(element => {
                if( !this.lanAndSSIDEnable[element]) // 如果端口没有使能则不解除
                    this.G_BindPort[element] = false
            });
        },
        changeWanMode(value){
            if(value === '1')  // Bridge
            {
                // 上行方式重置为DHCP
                this.wanForm[this.wanIndex].netType = '1'
                // 协议类型重置为 ipv4
                this.wanForm[this.wanIndex].protocolType = '1'

                // 重置业务类型选项
                this.wanServiceTypeArr = bridgeWanServiceType
                
                // 重置业务类型为INTERNET
                if(this.wanForm[this.wanIndex].serviceType != '1'
                && this.wanForm[this.wanIndex].serviceType != '3')
                    this.wanForm[this.wanIndex].serviceType = '1'

                
            }
            else if(value === '0') // Route
            {
                if(this.$G_DEVICE_CFG.area === 'WDC')
                    this.wanServiceTypeArr = routeWanServiceTypeForIPTV
                else
                    this.wanServiceTypeArr = routeWanServiceType
            }
            // 重置输入效验信息
            this.$refs['wanForm'].clearValidate()
        },
        changeWan(val){
            // 新增WAN
            if(val === '0')
            {
                // 每次选择新增是都要重置数据
                let C_defaultWANData = JSON.parse( JSON.stringify( defaultWANData ) )

                if(this.$isTRUE)
                {// TRUE 版本 新建 PPPoE WAN 默认填充账户密码
                    C_defaultWANData.PPPoE.userName = `${devConfig.getData().devMac.replace(/:/g,'')}@truehisp`
                    C_defaultWANData.PPPoE.password = 'password'
                }
                
                this.wanForm.splice(0,1,C_defaultWANData)
                
                // 检查WAN连接是否超过最大个数
                if(this.wanForm.length === this.maxWANNum + 1)
                {
                    this.$message.error(`Maximum number(${this.maxWANNum}) exceeded. Can't add new wan connection !`)
                    return
                }
            }
            // 切换WAN连接
            this.changeWanMode(this.wanForm[this.wanIndex].mode)
            this.initBindPort()

            
        },
        changeServerType(val){ // 修改业务类型
            if(this.wanForm[this.wanIndex].mode === '0' ) // only router
            {
                if(val === '3') // Other or IPTV 
                {
                    this.wanForm[this.wanIndex].nat = false;
                    this.wanForm[this.wanIndex].enableIGMPProxy = true;
                    this.wanForm[this.wanIndex].enableMLDProxy = true;
                }
                else
                {
                    this.wanForm[this.wanIndex].nat = true;
                    this.wanForm[this.wanIndex].enableIGMPProxy = false;
                    this.wanForm[this.wanIndex].enableMLDProxy = false;
                }
                
            }
            
        },
        clikcPPPoE(val){
            if(val != '3') return
            // 当选择PPPoE的时候 如果IPv6模式下地址获取方式 选择为bridge 则需要重置
            if(this.wanForm[this.wanIndex].protocolType === '3'
            || this.wanForm[this.wanIndex].protocolType === '2')
            {
                if(this.wanForm[this.wanIndex].ipv6.addressAutoType != '3'
                && this.wanForm[this.wanIndex].ipv6.addressAutoType != '2')
                {
                    this.wanForm[this.wanIndex].ipv6.addressAutoType = '3'
                }
            }
        },
        applyWAN(){

            this.$refs['wanForm'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
            
            
        },
        deleteWAN(){
            axios
            .post("/boafrm/fhWANService",{CmdType:"DEL_WAN",index:this.wanForm[this.wanIndex].index})
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.$message.success("Delete successful!")
                    this.getData()
                }
                else
                {
                    this.loading = false
                    this.$message.error(`Delete failed! Error:${response.data.errMsg}`)
                }
            })
        },
        // PPPoE 手动连接
        pppManualConnect(action){
            let index = parseInt(this.wanIndex) - 1
            if(!(getWANDataCache[index].mode === '0'
            && getWANDataCache[index].netType === '3'
            && getWANDataCache[index].PPPoE.dialMode === '2'))
            {
                this.$message.error('Please save the current configuration first!')
                return
            }
            this.$refs['wanForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    axios
                    .post("/boafrm/fhWANService",{
                        CmdType:"PPPoE_MANUAL",
                        pppManual:action,
                        wanIndex:this.wanForm[this.wanIndex].index})
                    .then((response)=>{
                        if(response.data.ret === 0)
                        {
                            this.$message.success(`${action} successful!`)
                            this.loading = false
                        }
                        else
                        {
                            this.loading = false
                            this.$message.error(`${action} failed! Error:${response.data.errMsg}`)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        refreshWAN(){
            this.getData()
        },
        getData(){
            this.loading = true

            // 每次获取数据都需要重置add WAN数据
            let C_defaultWANData = JSON.parse( JSON.stringify( defaultWANData ) )
            this.wanForm.splice(0,1,C_defaultWANData)

            axios
            .post("/boafrm/fhWANService",{CmdType:"GET_WAN"})
            .then((response)=>{
                this.loading = false                
                if(response.data.ret === 0)
                {
                    // 每次获取数据 都要清空所有WAN数据
                    this.wanForm = []
                    this.wanForm.splice(0,1,C_defaultWANData)

                    // 缓存这次获取WAN连接数据
                    getWANDataCache = JSON.parse( JSON.stringify( response.data.wanLists ) )

                    // 端口9 5G最后一个 现在用来绑定 MESH状态 所以永远可用
                    response.data.bindPort[9] = false

                    // 保存所有端口使能状态
                    this.lanAndSSIDEnable = response.data.bindPort.slice()

                    // 禁用不可用LAN and SSID
                    this.G_BindPort = response.data.bindPort
                    // WAN连接数据
                    response.data.wanLists.forEach(element => {
                        this.wanForm.push(element)
                        // 把帮的端口加入全局端口绑定数组
                        element.bindPort.forEach(element => {
                            this.G_BindPort[element] = true
                        })
                    })
                    
                    // 全局端口绑定数组缓存起来
                    this.defaultBindPort = this.G_BindPort.slice()
                    // 最大WAN连接数
                    this.maxWANNum = response.data.maxWANNum

                    if(this.wanForm.length > 1)
                        this.wanIndex = '1'
                    else
                        this.wanIndex = '0'

                    this.changeWan('1')
                }
                else
                {
                    this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
                }
                
            })
        },
        setData(){
            let postData = JSON.parse( JSON.stringify( this.wanForm[this.wanIndex] ) )
            postData.CmdType = "SET_WAN"
            postData.bindPort =  postData.bindPort.join(',')
            let ipv6Addr = postData.ipv6.address.split('/')

            postData.ipv6.address = ipv6Addr[0]
            postData.ipv6.prefixLen = ipv6Addr[1] || 64
       

            this.loading = true
            axios
            .post("/boafrm/fhWANService",postData)
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.$message.success("Configuration is successful!")
                    this.getData()
                }
                else
                {
                    this.loading = false
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                }
                    
            })
        }
    }
}
</script>
